import * as React from 'react';
import { SyntaxHighlighter, initializeSyntaxHighlights, getSyntaxHighlightStyle } from '../../syntax-highlighter';
export class CodeComponent extends React.PureComponent {
    constructor(props) {
        super(props);
        initializeSyntaxHighlights();
    }
    render() {
        const { props } = this;
        return (React.createElement("div", { className: 'component code-component', "data-component-type": 'code' },
            React.createElement("div", { className: 'code-container', "data-language": props.value.language },
                React.createElement(SyntaxHighlighter, { codeTagProps: { className: 'code' }, language: props.value.language, wrapLines: props.value.lineWrapping, style: getSyntaxHighlightStyle(), showLineNumbers: true }, props.value.code))));
    }
}
